import _ from "lodash";
import { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import useSWR from "swr";
import { URLS } from "../../../services/urls";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import "../Home.css"; // Assurez-vous que les styles sont là

const JobsByLocation = ({ locations }) => {
  const [lastImage, setLastImage] = useState(null);
  const { t } = useTranslation();

  // Récupération de l'image de fond dynamique
  const { data: cals } = useSWR(URLS.CAROUSSEL.list());

  useEffect(() => {
    if (cals && cals.results) {
      const userImages = cals.results.filter(
        (item) => item.image_list.step === "country"
      );
      if (userImages.length > 0) {
        setLastImage(userImages[userImages.length - 1]);
      }
    }
  }, [cals]);

  // Optimisation du tri des locations
  const sortedLocations = useMemo(() => {
    if (!locations) return [];
    return _.orderBy(
      locations,
      [
        ({ job_offers }) => (job_offers ? job_offers.length : 0),
        "name"
      ],
      ["desc", "asc"]
    ).slice(0, 8);
  }, [locations]);

  // Style dynamique pour le background de la section
  const sectionStyle = lastImage
    ? { 
        backgroundImage: `url(${lastImage.image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed' // Effet Parallaxe cool
      }
    : { backgroundColor: '#f4f7fa' }; // Fallback

  return (
    <section className="section-box mt-50 location-section" style={sectionStyle}>
      {/* Overlay sombre pour faire ressortir le texte et les cartes */}
      <div className="location-overlay"></div>
      
      <div className="container position-relative z-1">
        <div className="text-center mb-50">
          <h2 className="section-title text-white mb-10 wow animate__animated animate__fadeInUp">
            {t("textByLocation")}
          </h2>
          <p className="font-lg text-white opacity-75 wow animate__animated animate__fadeInUp">
            {t("textByLocationText")}
          </p>
        </div>

        <div className="row">
          {sortedLocations.map((location) => (
            <div
              key={"pop-loc-" + location.id}
              className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4"
            >
              <Link to={`/search?location=${location?.name ?? ""}`}>
                <div className="card-location-modern hover-up">
                  
                  {/* Icône de localisation stylisée */}
                  <div className="icon-box">
                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                  </div>

                  <div className="card-info">
                    <h5 className="location-name">{location.name}</h5>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <span className="job-count">
                            {location?.job_offers?.length || 0} {t("textVacancy")}
                        </span>
                        <span className="arrow-link">
                            <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                    </div>
                  </div>

                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default JobsByLocation;